import React, { useContext } from 'react';
import { withRouter } from 'utils/navigation/withRouter';
import { Page } from 'components/layout/panel/Page/Page';
import { Breadcrumb } from 'components/shared/navigation/Breadcrumbs/Breadcrumb';
import { LocaleContext } from 'context/locale';
import { EditContainer } from 'components/institution/Edit/EditContainer';
import { RFC } from '@typings/extra-react-router';
import { ROUTE_INSTITUTION_EDIT } from 'config/routes';
import { makePath } from 'utils/navigation/makePath';

const InstitutionEditComponent: RFC<{ id: string }> = (props) => {
  const { trans } = useContext(LocaleContext);

  const institutionId = props.match.params.id;

  return (
    <Page title={trans('INSTITUTIONS.EDIT.HEADER')}>
      <Breadcrumb
        label={trans('BREADCRUMB.UNITS.INSTITUTION-EDIT')}
        to={makePath(ROUTE_INSTITUTION_EDIT, { id: institutionId })}
      />
      <EditContainer institutionId={institutionId} goBack={props.history.goBack} />
    </Page>
  );
};

export const InstitutionEdit = withRouter(InstitutionEditComponent);
